// TODO: use placeholders on loading
<template>
  <div v-loading="$wait.waiting(_uid)" class="card text-left">
    <div class="card-content">
      <acl :permissions="['companies_update']">
        <div class="text-right control-button-wrapper pt-xxs">
          <acl :permissions="['companies_update']">
            <button
              class="btn btn-info btn-fill btn-wd submit-button"
              :class="{ loading: $wait.waiting(_uid) }"
              @click="goToEdit"
            >
              Edit
              <i
                v-show="$wait.waiting(_uid)"
                class="fas fa-circle-notch loading-icon"
              />
            </button>
          </acl>
        </div>
      </acl>

      <div class="row mt-s">
        <div class="col-xs-12">
          <b>Company Name</b>

          <ul class="list-unstyled mt-xxxs">
            <li>{{ company.name }}</li>
          </ul>
        </div>
      </div>

      <div class="row mt-s">
        <acl :roles="['Admin', 'Customer Support']">
          <div class="col-xs-12">
            <b>Tier</b>

            <ul class="list-unstyled mt-xxxs">
              <li>{{ company.tier.name }}</li>
            </ul>
          </div>

          <div class="col-xs-12 mt-xs">
            <b>Saleforce account</b>

            <ul class="list-unstyled mt-xxxs">
              <li>{{ company.salesForce }}</li>
            </ul>
          </div>
        </acl>
      </div>

      <hr />

      <div class="row mb-s pb-s">
        <div class="col-xs-12">
          <h5 class="text-info">
            <b>Operational Information</b>
          </h5>
        </div>

        <div class="col-xs-12 col-md-6">
          <b> Registry, Purpose, Equipment </b>
          <ul class="list-unstyled mt-xxxs">
            <li v-for="rpe in company.rpes" :key="rpe.id">
              {{ rpe.name }}
            </li>
          </ul>
        </div>

        <div class="col-xs-12 col-md-6">
          <b>Roles</b>
          <ul class="list-unstyled mt-xxxs">
            <li v-for="role in company.roles" :key="role.id">
              {{ role.name }}
            </li>
          </ul>
        </div>
      </div>

      <div class="clearfix mb-s" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("companyStore", { company: "currentCompany" }),
    ...mapGetters("loadingStore", { isLoading: "loading" }),
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      this.getCompanyById(this.company.id);
      this.$wait.end(this._uid);
    } catch (error) {
      this.addNewError(error);
    }
  },
  methods: {
    ...mapActions("companyStore", ["getCompanyById"]),
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    goToEdit() {
      return this.$router.push({ name: "companies@edit" });
    },
  },
};
</script>

<style scoped>
ul.contact li {
  line-height: calc(100% + 4px);
}
</style>
